<template>
  <div class="borrowerAttributeTextArea">
    <BorrowerAttributeConstructor
      :questionText="questionText"
      :description="description"
      :descriptionTooltip="descriptionTooltip"
      :label="label"
      :label-for="'ba' + identifier"
      :tooltipText="tooltipText"
      :errorText="errorText"
      :helpText="helpText"
      :disclaimer="disclaimer">
      <template v-slot:input>
        <textarea :id="'ba' + identifier"
          :name="'ba' + identifier"
          :data-cy="question.alias"
          :dreams-id="question.alias"
          class="form-control"
          type="text"
          :class="{'is-invalid': v$.value && v$.value.$invalid && v$.value.$dirty}"
          :placeholder="question.placeholder"
          :pattern="question.pattern"
          :disabled="disabled"
          v-model="value"
          @blur="onBlur(v$.value)"
          @change="onChange(v$.value, value)"
        ></textarea>
      </template>
    </BorrowerAttributeConstructor>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, minLength, email } from '@vuelidate/validators'
import BorrowerAttributeConstructor from './BorrowerAttributeConstructor.vue'
import get from 'lodash/get'

export default {
  components: {
    BorrowerAttributeConstructor
  },
  props: {
    updateIndex: Number,
    question: Object,
    disabled: Boolean,
    updateStoreValue: Function
  },
  emits: ['invalidity','answer'],
  setup: () => ({ v$: useVuelidate() }),
  data () {
    return {
      value: '',
      errorMessage: 'This field is invalid',
    }
  },
  computed: {
    identifier() {
      return this.question.id || this.question.alias
    },
    invalid() {
      return this.v$.$invalid
    },
    // element computed fields
    questionText() {
      return this.question.questionText || ''
    },
    description() {
      return this.question.description || ''
    },
    descriptionTooltip() {
      return this.question.descriptionTooltip || ''
    },
    label() {
      return this.question.name || ''
    },
    tooltipText() {
      return this.question.tooltip || this.question.helpText || ''
    },
    helpText() {
      return this.question.tooltip ? this.question.helpText : ''
    },
    errorText() {
      return get(this.v$, 'value.$error') ? this.errorMessage : ''
    },
    disclaimer() {
      return this.question.disclaimer || ''
    },
  },
  created () {
    this.$watch('invalid', (invalid) => {
      this.$emit('invalidity', invalid)
    }, {immediate: true})

    this.value = this.question.value
    this.errorMessage = 'Please enter a value'
  },
  validations: function () {
    return {
      value: {
        minLength: minLength(3),
        required
      }
    }
  },
  methods: {
    onBlur (v$) {
      v$.$touch()
    },

    onChange (v$, value) {
      this.$emit('answer', {
        value: value,
        isInvalid: v$.$error
      })
    }
  }
}
</script>
